<template>
  <div
    :class="`statement_settings--month ${
      statements && statements.length > 1 ? 'multi-statement' : ''
    }`"
    ref="statementSettingsMonth"
  >
    <div
      v-for="statement of statements"
      :key="statement.statement_id"
      @click="onStatementSettingsMonthClick"
      :class="`statement_settings--statement ${
        statement
          ? statement.tile_colour == 'green'
            ? statement
              ? statement.invoice_id != null
                ? `stgreen`
                : 'storange'
              : ''
            : statement.tile_colour == 'red'
            ? 'stred'
            : ''
          : ''
      }`"
    >
      <div class="left-bar"></div>
      <div v-if="statement" class="statement-details">
        <div
          @click.stop="(e) => $emit('statment_click', statement)"
          class="invoice_ref ut-link ut-font-upper"
          :title="statement.invoice_ref || statement.external_ref"
          v-if="statement.invoice_ref || statement.external_ref"
        >
          {{ statement.invoice_ref || statement.external_ref }}
        </div>
        <div
          class="import_status ut-link"
          v-if="import_statusText(statement)"
          @click.stop="(e) => $emit('statment_click', statement)"
        >
          {{ import_statusText(statement) }}
        </div>
        <div class="ut-flex ut-fw ut-jbetween">
          <div
            class="statement_amount ut-link ut-flex ut-jbetween"
            @click.stop="(e) => onStatementAmountClick(statement)"
          >
            <div>
              {{ $dft.curr(statement.statement_amount || 0) }}
              {{ statement.currency_iso }}
            </div>
          </div>
          <img
            v-if="
              statement.invoice_ref != null || statement.external_ref != null
            "
            style="height: 13px; margin-right: 8px; margin-left: 15px"
            src="static/icons/check-mark.svg"
            class="v5 s2"
          />
        </div>
      </div>
      <div v-if="statement && !statement.invoice_id" class="right-icon">
        <img
          src="static/icons/plus-blue.svg"
          class="dt-icon v7 s0 add-icon--plus"
          alt
        />
        <img
          @click.stop="deleteStatement(statement)"
          src="static/icons/close-red.svg"
          class="dt-icon v7 s0 add-icon--plus"
          alt
        />
      </div>
    </div>
    <template
      v-if="statements.length == 0 && sender_royalty_periods.length > 0"
    >
      <div
        @click="onStatementSettingsMonthClick"
        :class="`statement_settings--statement stblue`"
        v-for="sender_royalty_period of sender_royalty_periods"
        :key="sender_royalty_period.start_date"
      >
        <div class="left-bar"></div>
        <div
          class="statement-details"
          @click.stop="(e) => onRoyaltyPeriodClick(sender_royalty_period)"
          :title="
            sender_royalty_periodTitle(sender_royalty_period) +
            sender_royalty_period.status
              ? sender_royalty_period.status
              : ''
          "
        >
          <div class="invoice_ref ut-link ut-font-upper">
            <!-- <pre style="font-size: 10px">
              {{ statement_setting.statement_period }}
              {{ sender_royalty_period.start_date }}
              {{ sender_royalty_period.end_date }}
            </pre> -->
            {{ sender_royalty_periodTitle(sender_royalty_period) }}
          </div>
          <div v-if="sender_royalty_period.status" class="import_status">
            {{ sender_royalty_period.status }}
          </div>
        </div>
      </div>
    </template>
    <!-- <div
      @click="onStatementSettingsMonthClick"
      :class="`statement_settings--statement ${
        this.isSettingsInYellowPeriod ? `styellow` : ''
      }`"
      v-if="statements.length == 0 && sender_royalty_periods.length == 0"
    >
      <div class="left-bar"></div>
      <div class="add-icon">
        <div class="add-icon--plus">+</div>
        <div class="add-icon--text">Add Import</div>
      </div>
    </div> -->
    <!-- <h2>{{ maxStatements }}</h2> -->
    <div
      @click="onStatementSettingsMonthClick"
      :class="`statement_settings--statement ${
        isSettingsInYellowPeriod && hasNoImportOrRoyaltyPeriod(index)
          ? `styellow`
          : ''
      }`"
      v-for="(statementAutoImport, index) of statementAutoImportArray"
      :key="index"
    >
      <div class="left-bar"></div>
      <div class="add-icon">
        <div class="add-icon--plus">+</div>
        <div class="add-icon--text">{{$t('add_import')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { snakeCaseToWords, wait } from "../../../../utility";
import { distributionStatementListLDTRoutes } from "../../router/routes";

export default {
  props: ["statement_setting", "currentYear", "month", "maxStatements"],
  data() {
    return {
      // statementAutoImportArray: [],
    };
  },
  computed: {
    // sender_royalty_periods() {
    //   return this.statement_setting.sender_royalty_periods || [];
    // },
    monthDate() {
      return new Date(this.yearMonth);
    },
    isSettingsInYellowPeriod() {
      // console.log({'statement_settings_month.vue:146 this.statement_setting' : this.statement_setting});
      const isMonthPeriod =
        this.statement_setting.statement_period == "monthly";
      const isQuaterPeriod =
        this.statement_setting.statement_period == "quarterly";
      const isHalfYearPeriod =
        this.statement_setting.statement_period == "halfyear";
      const isYearPeriod = this.statement_setting.statement_period == "year";

      // const isMonthPeriodEnded = true;
      const quarterEnded = this.month % 3 == 0;
      const halfYearEnded = this.month % 6 == 0;
      const yearEnded = this.month == 12;

      if (
        this.statement_setting.start_date &&
        this.statement_setting.end_date &&
        new Date(this.statement_setting.start_date.substr(0, 7)) <= this.monthDate &&
        new Date(this.statement_setting.end_date.substr(0, 7)) >= this.monthDate &&
        this.statementSettingsPeriodMatch
      ) {
        return true;
      }
    },
    statementSettingsPeriodMatch() {
      // const isMonthPeriod = this.statement_setting.statement_period == "monthly";
      const isQuaterPeriod =
        this.statement_setting.statement_period == "quarterly";
      const isHalfYearPeriod =
        this.statement_setting.statement_period == "halfyear";
      const isYearPeriod = this.statement_setting.statement_period == "year";

      // const isMonthPeriodEnded = true;
      const quarterEnded = this.month % 3 == 0;
      const halfYearEnded = this.month % 6 == 0;
      const yearEnded = this.month == 12;

      if (
        (isQuaterPeriod ? quarterEnded : true) &&
        (isHalfYearPeriod ? halfYearEnded : true) &&
        (isYearPeriod ? yearEnded : true)
      ) {
        return true;
      }
    },
    statements() {
      return this.statement_setting.statements.filter((st) => {
        if (
          (st.statement_period_txt == `M${this.month}` ||
            (this.month % 3 == 0 &&
              st.statement_period_txt == `Q${Math.floor(this.month / 3)}`) ||
            st.statement_period_txt == `S${this.month / 6}` ||
            (st.statement_period_txt == `Y` && this.month == 12)) &&
          this.currentYear == st.statement_year
        ) {
          return true;
        }
      });
    },
    sender_royalty_periods() {
      const start_date = new Date(this.statement_setting.start_date);
      const end_date = new Date(this.statement_setting.end_date);
      return this.statement_setting.sender_royalty_periods
        .map((rp) => {
          const startYear = rp.start_date.slice(0, 4);
          const startMonth = rp.start_date.slice(5, 7);
          const endYear = rp.end_date.slice(0, 4);
          const endMonth = rp.end_date.slice(5, 7);
          const rpEndDate = new Date(rp.end_date);

          return {
            ...rp,
            startYear,
            startMonth,
            endYear,
            endMonth,
            rpEndDate,
          };
        })
        .filter((rp) => {
          const { startYear, startMonth, endYear, endMonth, rpEndDate } = rp;

          // if (rp_month in monthIndex && rp_year == year && (year_month >= start_date && year_month <= end_date)) {

          if (
            this.statement_setting.account_name == "MTN" &&
            this.month == 7 &&
            this.currentYear == 2023
          ) {
            console.log({
              MTN: 1,
              rp,
              start_date,
              end_date,
              rpEndDate,
              endMonth,
              endYear,
              this_month: this.month,
              this_year: this.currentYear,
              this_statement_setting: this.statement_setting,
              "rpEndDate >= start_date": rpEndDate >= start_date,
              "rpEndDate <= end_date": rpEndDate <= end_date,
              "this.statementSettingsPeriodMatch":
                this.statementSettingsPeriodMatch,
            });
          }

          if (
            endYear == this.currentYear &&
            endMonth == this.month &&
            rpEndDate >= start_date &&
            rpEndDate <= end_date
          ) {
            return true;
          }

          // if (
          //   +startMonth <= this.month &&
          //   +startYear <= this.currentYear &&
          //   endYear >= this.currentYear &&
          //   endMonth >= this.month &&
          //   this.statementSettingsPeriodMatch
          // ) {
          //   return true;
          // }
        });
    },
    yearMonth() {
      return `${this.currentYear}-${String(this.month).padStart(2, '0')}`;
    },
    statementAutoImportArray() {
      // if (this.statement_setting.account_name == "Bongo Joe" &&
      //   this.statement_setting.description == "Cost Import EUR"
      // ) {
      //   console.log({
      //     "statement_settings_month.vue:146 this.statement_setting":
      //       this.statement_setting,
      //   });
      //   console.log({
      //     maxStatements: this.maxStatements,
      //     "this.statements.length": this.statements.length,
      //     "this.sender_royalty_periods.length":
      //       this.sender_royalty_periods.length,
      //     [`this.maxStatements -
      //     (this.statements?.length || 0) -
      //     (this.statements?.length == 0 && this.sender_royalty_periods.length > 0
      //       ? 1
      //       : 0)`]:
      //       this.maxStatements -
      //       (this.statements?.length || 0) -
      //       (this.statements?.length == 0 &&
      //       this.sender_royalty_periods.length > 0
      //         ? 1
      //         : 0),
      //   });
      // }
      return Array(
        Math.abs(
          this.maxStatements -
            (this.statements?.length || 0) -
            (this.statements?.length == 0 &&
            this.sender_royalty_periods.length > 0
              ? 1
              : 0)
        )
      ).fill(0);
    },
  },
  watch: {
    statement_setting: {
      async handler(to, from) {
        // await wait(100);
        // this.computeAutoImportBlankSize();
        // await wait(1000);
        // this.computeAutoImportBlankSize();
      },
      immediate: true,
    },
  },
  methods: {
    getStatements() {},
    onAddStatementSettingsClick() {},
    deleteStatement(statement) {
      this.$emit("deleteStatement", statement);
    },
    import_statusText(statement) {
      if (statement && statement.import_status == "complete") {
        return `Upload Complete`;
      } else {
        return snakeCaseToWords(statement.import_status || "");
      }
    },
    onStatementSettingsMonthClick() {
      console.log("import_click", 1);
      this.$emit("import_click", {
        ...this.statement_setting,
        month: this.month,
        year: this.currentYear,
      });
    },
    onStatementAmountClick(statement) {
      this.$emit("statment_click", statement);
    },
    sender_royalty_periodTitle(sender_royalty_period) {
      return `Statement M${sender_royalty_period?.startMonth} ${
        sender_royalty_period?.startMonth != sender_royalty_period?.endMonth
          ? `-M${sender_royalty_period?.endMonth}`
          : ""
      }`;
    },
    get_statement_setting_senderTitle() {
      return `${this.statement_setting.sender} (${this.statement_setting.digital_physical})`;
    },

    onRoyaltyPeriodClick(sender_royalty_period) {
      console.log({'statement_settings_month.vue:377 sender_royalty_period' : sender_royalty_period});
      this.$emit("rp_click", {
        statement_setting: this.statement_setting,
        statement_period_txt: `M${parseInt(sender_royalty_period.endMonth)}`,
        year: sender_royalty_period.startYear,
        sender_royalty_period,
        sender_royalty_periodTitle: this.sender_royalty_periodTitle(
          sender_royalty_period
        ),
        statement_setting_senderTitle: this.get_statement_setting_senderTitle(
          this.statement_setting
        ),
      });
    },
    computeAutoImportBlankSize() {
      let statementSize =
        this.$refs["statementSettingsMonth"].getBoundingClientRect()?.height /
        52;
      statementSize = statementSize - this.statements.length;
      if (
        this.statements.length == 0 &&
        this.sender_royalty_periods.length > 0
      ) {
        statementSize--;
      }
      this.statementAutoImportArray = Array(statementSize).fill(1);
    },
    hasNoImportOrRoyaltyPeriod(index) {
      return (
        index == 0 &&
        this.statements.length == 0 &&
        this.sender_royalty_periods.length == 0
      );
    },
    //MARK: Methods
  },
};
</script>
<style lang="scss">
</style>